import React, { Component } from 'react';
//css
import './FieldsErrorPopup.scss';

export default function FieldErrorPopup(props) {
    return (
        <div className="fields-error-popup-container scale-in-center">
            <div onClick={props.closePopup}>
                <img className="fields-error-popup-x" src="/images/otherIcons/x-black.png" />
            </div>
            <img src="/images/otherIcons/warning.svg" className="fields-error-popup-warning" />
            <div className="fields-error-popup-text">{props.text}</div>
        </div >
    );
}